"use client";

import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BathroomProjectCtaBand() {
  return <section id="bathroomprojectctaband" data-nav="dark" className="relative w-full overflow-hidden bg-secondary text-secondary-foreground py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center text-center">
          <div aria-hidden="true" className="mb-6 h-0.5 w-12 bg-primary/80" />

          <h2 className="font-serif text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl text-balance max-w-3xl leading-tight">
            Ready to start your Brookhaven bathroom project?
          </h2>

          <p className="mt-5 max-w-2xl text-base sm:text-lg text-secondary-foreground/85 leading-relaxed">
            Schedule an on-site consultation to review your layout ideas, get clear budget guidance, and we will follow up to discuss your project.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <motion.div whileHover={{
            y: -2
          }} transition={{
            duration: 0.18,
            ease: "easeOut"
          }} className="w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground font-medium shadow-md hover:bg-primary/90 px-7 h-12 text-base transition-colors">
                <Link to="/ContactRequestAnEstimatePage">
                  Request an Estimate
                </Link>
              </Button>
            </motion.div>

            <motion.div whileHover={{
            y: -2
          }} transition={{
            duration: 0.18,
            ease: "easeOut"
          }} className="w-full sm:w-auto">
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/30 bg-secondary/40 text-secondary-foreground hover:bg-secondary-foreground/10 hover:text-secondary-foreground px-6 h-12 text-base transition-colors">
                <a href="tel:+14708479076" className="inline-flex items-center gap-2">
                  <Phone className="size-4 shrink-0 text-primary" aria-hidden="true" />
                  <span>Call (470) 847-9076</span>
                </a>
              </Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}